<template>
  <div id="csContainer">
      <div class="rotate">
          <el-input size="small " class="city" placeholder="所在城市: " v-model = 'city' clearable></el-input>
          <el-button class="submit" @click="findPin()" size="small "slot="append" icon="el-icon-search" type="primary" >搜索</el-button>

          <el-col  size="small " class="site">
              <el-autocomplete
                      class="inline-input"
                      size="small"
                      v-model="location"
                      :fetch-suggestions="querySearch"
                      placeholder="请输入地点: "
                      :trigger-on-focus="false"
                      @select="handleSelect"

              ></el-autocomplete>
          </el-col>
      </div>
<!--      <el-input size="small " class="speed" placeholder="输入地点: 如北京灵图软件" v-model = 'location' clearable></el-input>-->

  </div>



</template>


<script>
    /*eslint-disable*/
    import * as Cesium from "cesium/Cesium";
    import widgets from "cesium/Widgets/widgets.css";
    import axios from 'axios'
    import qs from 'qs'
    import util from "../../components/util"
    export default {
        name: 'headMap',
        data(){
            return{
                isShow: false,
                viewer: null,
                location: null,
                flocation:null,
                city: null,
                search: [],
                info :null,
                restaurants: null
            }
        },
        watch :{
          location:function (val) {
              let self = this;
              axios.get('http://api.smartmapx.com/ls',{
                  params:{
                      keywords: val,
                      city: self.city,
                      apikey: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJuYmYiOjE1NzA2NzA4NTksImRhdGEiOiJ7XCJjb3JwX2xpbmtcIjpcIlwiLFwiZ2VuZGVyXCI6MCxcInVzZXJfbmFtZVwiOlwiemhhbmd6aGVuXCIsXCJ1c2VyX29yaWdpbl9pZFwiOlwiZm1fbG9jYWxcIixcImF2YWlsYWJsZVwiOjAsXCJleHBpcmVfdGltZVwiOjE1Nzg0NzUwNDgsXCJpc19hZG1pbmlzdHJhdG9yXCI6MCxcInR5cGVcIjpcIuWFjei0ueeJiFwiLFwiY29ycF9uYW1lXCI6XCJcIixcInByb2R1Y3Rfb3B0aW9uc19pZFwiOlwiXCIsXCJsb2dpbl9uYW1lXCI6XCJ6aGFuZ3poZW5cIixcInVzZXJfaWRcIjpcImY5NDhlOWY4LWRkODItNDk3MC04Mjk3LTY2MDFhNjQyYWRiM1wiLFwicHJvZHVjdF9pZFwiOlwiYzQ5ODUxNDktNmU5YS00ZjNiLThjOGYtZjM1ZmMwNWRiYmVmXCIsXCJzb3VyY2VfaWRcIjpcIlwiLFwiY29ycF9pZFwiOlwibHRfbWFwXCJ9IiwiZXhwIjo0MDkyNTk5MzQ5LCJqdGkiOiJhX2EwZWNjZDBmOGNmMjQyYWI4OGMwYWY1MDdhYmYxODkzIn0.opE_ijQCSXthATKj6p7JRFSgBx7z3qFiEAnUCqoFgtI',
                  }
              })
              .then(function (response) {
                  self.search = response;

                  if (self.search.data.status !== "ERROR"){
                      self.flocation = self.search.data.pois;
                      if (self.flocation.length >= 10)
                      {
                          self.flocation = self.flocation.slice(0,10);
                      }
                  }
              })
          }
        },
        mounted(){
            this.init();
            this.restaurants = this.loadAll();
        },
        methods: {
            init() {
                let viewer = util.getViewer("csContainer", {
                    imageryProvider: new Cesium.UrlTemplateImageryProvider({
                        url: "http://webrd02.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=8&x={x}&y={y}&z={z}",
                    }),
                    // baseLayerPicker: false,
                    infoBox: true,
                    selectionIndicator: true,
                    homeButton: false,
                    sceneModePicker: false,
                    baseLayerPicker: false,

                });
                this.viewer = viewer;

                let  cf = new Cesium.Cartesian3(-4107046.6468334734, 15755722.58519879, 12073099.956117895)  ;

                this.viewer.camera.setView({
                    destination :cf,
                    orientation : {
                        heading : 6.21390483292924,
                        pitch : -1.5664340610879344,
                        roll : 0.0
                    }
                });
                // let ab = http://api.smartmapx.com/ls?keywords=东西湖&types=310303&page=1&size=2&apikey=<用户的key>
            },
            querySearch(queryString, cb) {
                this.restaurants = this.loadAll();
                if(this.restaurants !== null)
                {
                    cb(this.restaurants);
                }

            },

            loadAll() {
                let self = this;
                let result = [];
                let ab = self.flocation;
                if(self.flocation !==null){
                    for(let i=0;i<self.flocation.length;i++){
                        result.push({"value": self.flocation[i].name});
                    }
                    return result;
                }
            },
            handleSelect(item) {
                console.log(item);

            },
            findPin() {
                let self = this;
                    axios.get('http://api.smartmapx.com/ls',{
                        params:{
                            keywords: self.location,
                            city: self.city,
                            apikey: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJuYmYiOjE1NzA2NzA4NTksImRhdGEiOiJ7XCJjb3JwX2xpbmtcIjpcIlwiLFwiZ2VuZGVyXCI6MCxcInVzZXJfbmFtZVwiOlwiemhhbmd6aGVuXCIsXCJ1c2VyX29yaWdpbl9pZFwiOlwiZm1fbG9jYWxcIixcImF2YWlsYWJsZVwiOjAsXCJleHBpcmVfdGltZVwiOjE1Nzg0NzUwNDgsXCJpc19hZG1pbmlzdHJhdG9yXCI6MCxcInR5cGVcIjpcIuWFjei0ueeJiFwiLFwiY29ycF9uYW1lXCI6XCJcIixcInByb2R1Y3Rfb3B0aW9uc19pZFwiOlwiXCIsXCJsb2dpbl9uYW1lXCI6XCJ6aGFuZ3poZW5cIixcInVzZXJfaWRcIjpcImY5NDhlOWY4LWRkODItNDk3MC04Mjk3LTY2MDFhNjQyYWRiM1wiLFwicHJvZHVjdF9pZFwiOlwiYzQ5ODUxNDktNmU5YS00ZjNiLThjOGYtZjM1ZmMwNWRiYmVmXCIsXCJzb3VyY2VfaWRcIjpcIlwiLFwiY29ycF9pZFwiOlwibHRfbWFwXCJ9IiwiZXhwIjo0MDkyNTk5MzQ5LCJqdGkiOiJhX2EwZWNjZDBmOGNmMjQyYWI4OGMwYWY1MDdhYmYxODkzIn0.opE_ijQCSXthATKj6p7JRFSgBx7z3qFiEAnUCqoFgtI',
                        }
                    })
                    .then(function (response) {
                        self.info = response;
                        if(self.info.data.pois.length===1){
                            let lat = self.info.data.pois[0].latitude;
                            let lon = self.info.data.pois[0].longitude;
                            self.viewer.entities.removeAll();

                            self.viewer.entities.add({
                                name : self.location ,
                                description: '地址：   '+self.info.data.pois[0].address,
                                position : Cesium.Cartesian3.fromDegrees(lon, lat),
                                billboard :{
                                    image : 'img/marker.png',

                                    // verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                                },

                                label:{
                                    text:self.info.data.pois[0].name,
                                    font: '15px sans-serif',
                                    fillColor: Cesium.Color.BLACK,
                                    outlineWidth: 5,
                                    outlineColor: Cesium.Color.WHITE,
                                    pixelOffset: new Cesium.Cartesian2(20, 20),
                                    style: Cesium.LabelStyle.FILL_AND_OUTLINE
                                }
                            });

                            self.viewer.camera.flyTo({
                                destination : Cesium.Cartesian3.fromDegrees(lon, lat,1000),
                            });
                        }else {
                            self.viewer.entities.removeAll();
                            let mPoi = self.flocation;
                            for (let i =0;i<mPoi.length;i++)
                            {
                                let lat = mPoi[i].latitude;
                                let lon = mPoi[i].longitude;
                                self.viewer.entities.add({
                                    name : mPoi[i].name ,
                                    description: '地址：   '+mPoi[i].address,
                                    position : Cesium.Cartesian3.fromDegrees(lon, lat),
                                    label:{
                                        text: mPoi[i].name,
                                        font: '15px sans-serif',
                                        fillColor: Cesium.Color.BLACK,
                                        outlineWidth: 5,
                                        outlineColor: Cesium.Color.WHITE,
                                        pixelOffset: new Cesium.Cartesian2(20, 20),
                                        style: Cesium.LabelStyle.FILL_AND_OUTLINE
                                    },
                                    billboard :{
                                        image : 'img/marker.png',
                                        // verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                                    },

                                });


                            }
                            self.viewer.zoomTo(self.viewer.entities);
                        }
                    })
                    .catch(function (error) { // 请求失败处理
                        console.log(error);
                    });
            },
        }

    }
</script>
<style scoped>

    .city{
        position: absolute;
        width:101px;
        margin-left: 15px;
        margin-top:7px;
        z-index: 999;
    }
    .site{
        position: absolute;
        width:150px;
        margin-left: 15px;
        margin-top:50px;
        z-index: 999;
    }
    .site2{
        position: absolute;
        width:200px;
        margin-left: 180px;
        margin-top:50px;
        z-index: 999;
    }
    .submit {
        position: absolute;
        margin-left: 180px;
        margin-top:50px;
        z-index: 999;
    }
    .rotate{
        font-size: 5px;

        position: absolute;
        /*width:230px;*/
        margin-top: 7px;
        margin-left: 25px;
        /*right: 10px;*/
        z-index: 110;
        background-color: rgba(0, 0, 0, 0.5);
    }
    .rotate2{
        margin: 10px !important;
        color:white !important;
    }
  #csContainer {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: hidden;
  }


</style>
